import React, { memo } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import compose from 'recompose/compose';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { FormGroupTextarea, FormGroup } from '@paysera/react-common';
import FormGroupDropZone from '@assetsJsModule/dropzone';
import getFileSizeNotice from '@assetsJsModule/dropzone/service/getFileSizeNotice';

import validate from '../utils/contactUsFormValidation';
import removeLastSymbol from '../services/removeLastSymbol';
import {
    maxFileSize,
    maxNumberOfFiles,
    columnGridCount,
    allowedMimeTypes,
    maxTotalFilesSize,
} from '../config/constants';

const ContactUsForm = ({
    handleSubmit,
    onSubmit,
    submitting,
}) => {
    const { t } = useTranslation('PayseraContactFormBundle');

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup name="name" label={removeLastSymbol(t('contact_form.contact.name'))} type="text" />
            <FormGroup name="email" label={removeLastSymbol(t('contact_form.contact.email'))} type="text" />
            <FormGroup name="subject" label={removeLastSymbol(t('contact_form.contact.subject'))} type="text" />
            <FormGroupTextarea name="message" label={removeLastSymbol(t('contact_form.contact.message'))} rows="7" />

            <div className="form-group">
                <FormGroupDropZone
                    name="attachments"
                    contentBase64Encoded
                    maxFileSizeMB={maxFileSize}
                    maxTotalFilesSizeMB={maxTotalFilesSize}
                    maxTotalFilesCount={maxNumberOfFiles}
                    columnGridCount={columnGridCount}
                    notice={getFileSizeNotice(maxFileSize, maxNumberOfFiles)}
                    allowedMimeTypes={allowedMimeTypes}
                />
            </div>
            <div className="form-group">
                <Button
                    type="submit"
                    bsStyle="default"
                    disabled={submitting}
                >
                    {t('contact_form.contact.submit')}
                </Button>
            </div>
        </form>
    );
};

ContactUsForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
};

export default compose(
    withTranslation('validators'),
    reduxForm({
        form: 'contact-us',
        destroyOnUnmount: false,
        validate,
    }),
    memo,
)(ContactUsForm);
